import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpThinIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 12.2 14.8",
	style: { enableBackground: "new 0 0 12.2 14.8" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.arrow-up-thin-st0{opacity:0.3;}\n	.arrow-up-thin-st1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
		className: "st0",
		children: [/* @__PURE__ */ _jsx("path", {
			className: "arrow-up-thin-st1",
			d: "M6.1,14.3V0.5"
		}), /* @__PURE__ */ _jsx("path", {
			className: "arrow-up-thin-st1",
			d: "M0.5,6.2l5.6-5.7l5.6,5.6"
		})]
	}) }) })]
});
export default SvgArrowUpThinIcon;
